import React, { useState } from 'react';
import api from '../../../../../api';
import { ENDPOINTS as GENERAL_ENDPOINTS } from '../../../Utils/Endpoints';
import { useLogos } from '../../../../../context/LogoProvider';
import bgLogin from '../../../../Pages/img/bglogin.png';
import Header from '../../../../Pages/Header';
import { FaLock } from 'react-icons/fa';

export default function AvisosPrivacidadAceptar({ idUsuario, avisos, onFinished }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { getSystemImageUrl } = useLogos();
    const background = getSystemImageUrl('LOGIN', bgLogin);

    const currentAviso = avisos[currentIndex];
    const contenido = currentAviso?.AvisoContenido || currentAviso?.avisoContenido || '';

    const handleAccept = async () => {
        setLoading(true);
        try {
            const now = new Date();
            const fechaFirma = parseInt(
                now.getFullYear().toString() +
                (now.getMonth() + 1).toString().padStart(2, '0') +
                now.getDate().toString().padStart(2, '0')
            );

            await api.post(GENERAL_ENDPOINTS.avisosPrivacidadAceptar, {
                IdUsuario: idUsuario,
                IdAviso: currentAviso?.IdAviso || currentAviso?.idAviso,
                FechaFirma: fechaFirma,
                Version: 1,
                IdEmpresa: currentAviso?.IdEmpresa || currentAviso?.idEmpresa,
                Activo: true
            });

            if (currentIndex < avisos.length - 1) {
                setCurrentIndex(currentIndex + 1);
                setError('');
            } else {
                onFinished();
            }
        } catch (e) {
            console.error(e);
            setError(e.response?.data?.message || 'Error al aceptar el aviso de privacidad. Por favor intenta de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    const containerStyle = {
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1.5rem' // Reducido para dar más espacio al contenido
    };

    const cardStyle = {
        background: 'rgb(from var(--bg-card-login) r g b / 0.85)',
        borderRadius: '24px',
        backdropFilter: 'blur(16px)',
        padding: '2rem',
        boxShadow: 'inset 0 0 1px rgba(255, 255, 255, 0.4), 0 20px 50px rgba(0, 0, 0, 0.3)',
        width: 'min(900px, 95vw)',
        maxHeight: '80vh',
        color: '#fff',
        textAlign: 'center',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden'
    };

    return (
        <div className="page-container" style={{ position: 'fixed', inset: 0, zIndex: 10000, background: '#fff', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Header />

            <main className="page-main" style={{ display: 'flex', flex: 1, minHeight: 0 }}>
                <div style={containerStyle}>
                    <div style={cardStyle}>
                        <div style={{ flex: '0 0 auto' }}>
                            <h2 style={{ fontSize: '1.8rem', fontWeight: '700', margin: '0 0 0.3rem 0', letterSpacing: '-0.5px' }}>
                                Aviso de Privacidad
                            </h2>
                            <p style={{ color: 'rgba(255,255,255,0.6)', fontWeight: '500', marginBottom: '1.2rem', fontSize: '0.9rem' }}>
                                {currentIndex + 1} de {avisos.length}
                            </p>
                        </div>

                        {/* Contenedor del aviso - Maximizando área de lectura */}
                        <div
                            className="aviso-contenido-scroll"
                            style={{
                                flex: '1 1 auto',
                                overflowY: 'auto',
                                padding: '1.5rem',
                                background: 'rgba(0, 0, 0, 0.3)',
                                borderRadius: '16px',
                                border: '1px solid rgba(255, 255, 255, 0.05)',
                                textAlign: 'left',
                                fontSize: '1rem',
                                lineHeight: '1.7',
                                color: '#f8fafc',
                                marginBottom: '1.5rem',
                                scrollbarWidth: 'thin',
                                scrollbarColor: 'rgba(255,255,255,0.2) transparent'
                            }}
                        >
                            <div dangerouslySetInnerHTML={{
                                __html: (() => {
                                    const text = contenido || '<p style="text-align:center;">Cargando contenido...</p>';
                                    // Si parece HTML (tiene etiquetas), se deja igual. Si es texto plano, se convierten los saltos de línea.
                                    if (/<[a-z][\s\S]*>/i.test(text)) {
                                        return text;
                                    }
                                    return text.replace(/\n/g, '<br/>');
                                })()
                            }} />
                        </div>

                        <div style={{ flex: '0 0 auto' }}>
                            <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)', marginBottom: '1rem', fontStyle: 'italic' }}>
                                Al continuar, acepto los términos y condiciones de este aviso de privacidad.
                            </p>
                            <button className="login-form-button"
                                onClick={handleAccept}
                                disabled={loading}
                                style={{
                                    width: '100%',
                                    maxWidth: '350px',
                                    margin: '0 auto',
                                    height: '50px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '12px',
                                    fontSize: '1.1rem',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                                }}
                            >
                                <FaLock size={16} />
                                <span>{loading ? 'Procesando...' : (currentIndex < avisos.length - 1 ? 'Siguiente Aviso' : 'Aceptar y Finalizar')}</span>
                            </button>

                            {error && (
                                <p style={{ 
                                    color: '#ff5252', 
                                    fontSize: '0.9rem', 
                                    marginTop: '1rem', 
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    background: 'rgba(255, 82, 82, 0.1)',
                                    padding: '0.5rem',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(255, 82, 82, 0.3)'
                                }}>
                                    ⚠️ {error}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </main >
        </div >
    );
}
